import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo } from 'react';
const HEX_COLORS = {
    yellow: '#FFAC33',
    black: '#000000',
    currentColor: 'currentColor'
};
function getSizePx(powerPlayerBoltSize = 'default') {
    switch (powerPlayerBoltSize) {
        case 'small': {
            return 16;
        }
        case 'default': {
            return 20;
        }
        default: {
            return powerPlayerBoltSize;
        }
    }
}
export const PowerPlayerBolt = ({ color, size, isSubtle, withDropShadow }) => {
    const sizePx = getSizePx(size);
    const containerCss = useMemo(() => css(css `
          line-height: 1;
          width: ${sizePx}px;
          min-width: ${sizePx}px;
          height: ${sizePx}px;
          min-height: ${sizePx}px;
        `, withDropShadow &&
        css `
            filter: drop-shadow(1px 1px 0 rgb(0, 0, 0, 0.5));
          `), [sizePx, withDropShadow]);
    // the <div> wrapper with sizing prevents the SVG from getting scaled down when space is limited
    return (_jsx("div", { css: containerCss, children: _jsx("svg", { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 36 36', width: sizePx, height: sizePx, style: isSubtle ? { opacity: 0.4 } : {}, children: _jsx("path", { fill: HEX_COLORS[color], d: 'M32.938 15.651C32.792 15.26 32.418 15 32 15H19.925L26.89 1.458c.219-.426.106-.947-.271-1.243C26.437.071 26.218 0 26 0c-.233 0-.466.082-.653.243L18 6.588 3.347 19.243c-.316.273-.43.714-.284 1.105S3.582 21 4 21h12.075L9.11 34.542c-.219.426-.106.947.271 1.243.182.144.401.215.619.215.233 0 .466-.082.653-.243L18 29.412l14.653-12.655c.317-.273.43-.714.285-1.106z' }) }) }));
};
